import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import closeIcon from "../images/modal-close.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImages } from "@fortawesome/free-regular-svg-icons";

const PhotoUploader: React.FC = ({
  input,
  initialValues,
  deletePhoto,
}: any) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [imageUrl, setImageUrl] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [fileName, setFileName] = useState<string>("");
  const fileInputRef = useRef<HTMLInputElement>(null);

  const allowedTypes = ["image/jpeg", "image/png"];
  // const minSize = 2 * 1024 * 1024; // 2MB in bytes
  const maxSize = 2 * 1024 * 1024; // 2MB in bytes

  useEffect(() => {
    if (initialValues) {
      if (initialValues?.fileName) {
        // for binary image
        setError(null);
        setSelectedFile(initialValues);
        setFileName(initialValues?.fileName);
        // Decode base64 data to binary
        const binaryData = atob(initialValues.fileContent);

        // Create a Uint8Array to hold the binary data
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        // Create a Blob from the binary data
        const blob = new Blob([uint8Array], { type: "image/png" });
        const file = new File([blob], `${initialValues.fileName}.png`, {
          type: "image/png",
        });
        const imageUrl = URL.createObjectURL(file);
        setImageUrl(imageUrl);
        input.onChange(file);
      } else if (initialValues?.name) {
        setError(null);
        setSelectedFile(initialValues);
        setFileName(initialValues?.name);
        const imageUrl = URL.createObjectURL(initialValues);
        setImageUrl(imageUrl);
        input.onChange(initialValues);
      }
    }
  }, [initialValues]);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    if (file) {
      // Validate file type and size
      if (!allowedTypes.includes(file.type)) {
        setError("Only JPG and PNG files are allowed.");
        setSelectedFile(null);
        setImageUrl(null);
      } else if (file.size > maxSize) {
        setError("Maximum size 2MB");
        setSelectedFile(null);
        setImageUrl(null);
      } else {
        setError(null);
        setSelectedFile(file);
        setFileName(file.name);
        console.log(file);
        setImageUrl(URL.createObjectURL(file)); // Create temporary URL for the image
        input.onChange(file);
        event.target.value = ""; // Reset the file input field
      }
    }
  };

  const handleChooseFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDelete = () => {
    setFileName("");
    setSelectedFile(null);
    setImageUrl(null);
    input.onChange(null);
    deletePhoto();
  };

  return (
    <>
    {!imageUrl && <div className="upload-icon-container">
      <FontAwesomeIcon
        className="upload-icon"
        icon={faImages}
      />
    </div>}
    <div className="photo-uploader">
      {imageUrl && (
        <div className="delete">
          <img
            onClick={handleDelete}
            src={closeIcon}
            alt="close-icon"
            className="close"
          />
        </div>
      )}
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept=".jpg,.jpeg,.png"
        className={`inputFile ${imageUrl ? "present" : ""}`}
        disabled={imageUrl ? true : false}
      />
      <label
        onClick={handleChooseFileClick}
        className={`${imageUrl ? "present" : ""}`}
      >
        {fileName ? `${fileName}` : "Upload Logo"}
      </label>

      <div className="image-container">
        {imageUrl && <img src={imageUrl} alt="Uploaded" />}
      </div>
      {error && <div className="error-field">{error}</div>}
    </div>
    </>
  );
};

export default PhotoUploader;
